import { useCallback, useEffect, useMemo, useState } from 'react';
import { useSearchParams } from 'react-router-dom';
import TaskStatusPingInterruptionDrawer from 'domain/people/availability/interruprions/create/taskStatusPing/TaskStatusPingInterruptionDrawer';
import {
  MESSAGE_URL_PARAM,
  RECIPIENT_URL_PARAM,
} from 'domain/people/availability/interruprions/create/taskStatusPing/useTaskStatusPingInitialData';
import { InterruptionType } from 'domain/people/availability/interruprions/types';
import { Features } from 'infrastructure/featureToggle';
import useFeatureToggle from 'framework/featureToggle';

const INTERRUPTION_TYPE_URL_PARAM = 'type';

const useTaskStatusPingInterruptionDrawer = () => {
  const { isFeatureEnabled } = useFeatureToggle();
  const [searchParams, setSearchParams] = useSearchParams();
  const [isOpen, setIsOpen] = useState(false);
  const isInterruptionsFeatureEnabled = isFeatureEnabled(Features.INTERRUPTIONS);
  const isTaskStatusPingRequested = searchParams.get(INTERRUPTION_TYPE_URL_PARAM) === InterruptionType.TaskStatusPing;

  useEffect(() => {
    if (isTaskStatusPingRequested && isInterruptionsFeatureEnabled) {
      setIsOpen(true);
    }
  }, [isInterruptionsFeatureEnabled, isTaskStatusPingRequested]);

  const handleClose = useCallback(() => {
    setIsOpen(false);
  }, []);

  const clearTaskStatusPingUrlParams = useCallback(() => {
    const nextSearchParams = new URLSearchParams(searchParams);

    nextSearchParams.delete(INTERRUPTION_TYPE_URL_PARAM);
    nextSearchParams.delete(RECIPIENT_URL_PARAM);
    nextSearchParams.delete(MESSAGE_URL_PARAM);

    setSearchParams(nextSearchParams, { replace: true });
  }, [searchParams, setSearchParams]);

  const handleCreated = useCallback(() => {
    handleClose();
    clearTaskStatusPingUrlParams();
  }, [clearTaskStatusPingUrlParams, handleClose]);

  const taskStatusPingInterruptionDrawer = useMemo(() => {
    if (!isOpen || !isInterruptionsFeatureEnabled) {
      return null;
    }

    return <TaskStatusPingInterruptionDrawer isOpen={isOpen} onClose={handleClose} onCreated={handleCreated} />;
  }, [handleClose, handleCreated, isInterruptionsFeatureEnabled, isOpen]);

  return {
    taskStatusPingInterruptionDrawer,
  };
};

export default useTaskStatusPingInterruptionDrawer;
